// Get API URL from runtime config or fallback to build-time env or default
const getApiBaseUrl = () => {
  // First, try to read from window.__ENV__ (injected at runtime)
  if (window.__ENV__ && window.__ENV__.REACT_APP_API_URL) {
    return window.__ENV__.REACT_APP_API_URL;
  }
  // Second, try to read from a config.js file (loaded in index.html)
  if (window.APP_CONFIG && window.APP_CONFIG.REACT_APP_API_URL) {
    return window.APP_CONFIG.REACT_APP_API_URL;
  }

  return process.env.REACT_APP_API_URL || 'http://localhost:5050';
};

const API_BASE_URL = getApiBaseUrl();

// Get auth token
const getToken = () => {
  return localStorage.getItem('token');
};

// Application API Service
export const applicationService = {
  // Get all applications (with filters)
  getAllApplications: async (filters = {}) => {
    try {
      const token = getToken();
      const queryParams = new URLSearchParams();
      
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.search) queryParams.append('search', filters.search);
      if (filters.page) queryParams.append('page', filters.page);
      if (filters.limit) queryParams.append('limit', filters.limit);

      const url = `${API_BASE_URL}/api/applications${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || 'Failed to fetch applications');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Get application by ID
  getApplicationById: async (id) => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE_URL}/api/applications/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || 'Failed to fetch application');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Update application status (accept/reject)
  updateApplicationStatus: async (id, status) => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE_URL}/api/applications/${id}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || 'Failed to update application status');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Delete application
  deleteApplication: async (id) => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE_URL}/api/applications/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || 'Failed to delete application');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Submit application via webhook (public endpoint - no auth required)
  submitApplication: async (applicationData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/applications/webhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(applicationData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || 'Failed to submit application');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }
};

